/**
 * Supported field dropdown
 */
export class SupportedFieldDropdown {
  /**
   * OID
   */
  oid: number;

  /**
   * Reference OID
   */
  refOid: number;

  /**
   * Field ID
   */
  fieldId: number;

  /**
   * Ref table name
   */
  refTable: string;

  /**
   * Description
   */
  description: string;
}
